module.exports = __webpack_public_path__ + "static/img/itau.5783ad5b.svg";